function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import Select from "react-select";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import "./AdminViewLeave.css";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { VscLoading } from "react-icons/vsc";
import { LEAVE_DETAILS_FOR_STATUS_QUERY, LEAVE_DETAILS_FOR_STATUS_COUNT_QUERY, UPDATE_LEAVE_STATUS_MUTATION, LEAVE_DETAILS_FOR_STATUS_EXPORT_QUERY, GET_USER_LISTING_QUERY } from "./query";
// import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { stringToArrayOutput } from "./../SideMenu/Header";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { DELETE_LEAVE_DETAILS_MUTATION } from "./../ViewLeave/query";
import { LEAVE_SETTINGS_APPROVED_LIST_QUERY } from "./../LeaveSettings/query";
import { convertOrganisationTimezones } from "./../ViewLeave/ViewLeave";
import { decodeHtmlEntities, encodeHtmlEntities } from "../utils";
import { MdInfoOutline } from "react-icons/md";

// import { Field, Form, Formik, FieldArray } from "formik";
// import * as Yup from "yup";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import ControlLabel from "react-bootstrap/FormLabel";
// import FormControl from "react-bootstrap/FormControl";
// import FormGroup from "react-bootstrap/FormGroup";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Row, Col } from "react-bootstrap";
import { FaUserCircle, FaCalendarAlt, FaRegCalendar, FaTag, FaExclamationCircle, FaRegFileAlt, FaClock, FaRegClock, FaRegFilePdf } from "react-icons/fa";
import { FiTag, FiUser } from "react-icons/fi";
import { AiOutlineExclamationCircle } from "react-icons/ai";
var LIMIT = 10;
var offsets = 0;
var AdminViewLeave = function AdminViewLeave(props) {
  var _leaveSettingsApprove, _leaveSettingsApprove2, _userListData$getUser, _leaveCountData$leave, _leaveCountData$leave2, _leaveCountData$leave3, _leaveCountData$leave4, _leaveCountData$leave5, _leaveCountData$leave6, _leaveCountData$leave7, _leaveCountData$leave8;
  var _React$useState = React.useState("pending"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tabData = _React$useState2[0],
    setTabData = _React$useState2[1];
  var _React$useState3 = React.useState({
      label: "All Employees",
      value: ""
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userParameterCheck = _React$useState4[0],
    setUserParameterCheck = _React$useState4[1];
  var _React$useState5 = React.useState({
      label: "All Leaves",
      value: ""
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    leaveFilterCheck = _React$useState6[0],
    setleaveFilterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    startDate = _React$useState8[0],
    setStartDate = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    exportButton = _React$useState10[0],
    setExportButton = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    reviewedLeaveList = _React$useState12[0],
    setReviewedLeaveList = _React$useState12[1];
  var _React$useState13 = React.useState(new Date()),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    leaveYear = _React$useState14[0],
    setLeaveYear = _React$useState14[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    startTime = _useState2[0],
    setStartTime = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    endTime = _useState4[0],
    setEndTime = _useState4[1];
  var _React$useState15 = React.useState({
      label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY")),
      value: "".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"))
    }),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    financialCheck = _React$useState16[0],
    setFinancialCheck = _React$useState16[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    leaveSettingsUser = _React$useContext.leaveSettingsUser,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useState17 = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    last14Days = _React$useState18[0],
    setLast14Days = _React$useState18[1];
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    leaveDetailsShow = _React$useState20[0],
    setLeaveDetailsShow = _React$useState20[1];
  var handleLeaveDetailsClose = function handleLeaveDetailsClose() {
    setLeaveDetailsShow(null);
  };
  var handleLeaveDetailsShow = function handleLeaveDetailsShow(leaves) {
    setLeaveDetailsShow(leaves);
  };
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  // React.useEffect(() => {
  //   if (from == "web" && role == "Member") {
  //     props?.history.push("/my-work");
  //   }
  // }, [role]);

  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (from == "web" && (role == "Member" || role == "Head") && !leaveSettingsCheckForUser && role != "Admin") {
      if (role == "Head") {
        props === null || props === void 0 ? void 0 : props.history.push("/overview");
      }
      if (role == "Member") {
        props === null || props === void 0 ? void 0 : props.history.push("/my-work");
      }
    }
  }, [role, leaveSettingsCheckForUser]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var userList = [{
    label: "All Employees",
    value: null
  }];
  var _useQuery = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    leaveSettingsApprovedData = _useQuery.data,
    leaveSettingRefetch = _useQuery.refetch;
  var leaveStartTime = moment("Apr", "MMM").year(financialCheck === null || financialCheck === void 0 ? void 0 : financialCheck.value).startOf("month").format("YYYY-MM-DD HH:mm:ss");
  var leaveEndTime = moment("Mar", "MMM").year(financialCheck === null || financialCheck === void 0 ? void 0 : financialCheck.value).add(1, "year").endOf("month").format("YYYY-MM-DD HH:mm:ss");

  // React.useEffect(() => {
  //   let leaveApprovedSettings =
  //     leaveSettingsApprovedData && leaveSettingsApprovedData?.leaveSettingsApprovedUserList.length
  //       ? leaveSettingsApprovedData?.leaveSettingsApprovedUserList.find((o) => o.userId === user.userId)
  //       : null;

  //   if (!leaveApprovedSettings) {
  //     if (from == "web" && role == "Member") {
  //       props?.history.push("/my-work");
  //     } else if (from == "web" && role == "Head") {
  //       props?.history.push("/overview");
  //     }
  //   }
  // }, [leaveSettingsApprovedData]);

  function convertOrganisationTimezone(sD, tz) {
    var currentSystemTimezone = moment.tz.guess();
    var startTime = moment(sD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var endTime = moment(sD).tz(tz).format("YYYY-MM-DD HH:mm:ss");
    var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
    var zoneoffset = moment.tz(tz).utcOffset();
    if (zoneoffset !== currentSystemOffset) {
      var zoneoffsetTemp = Math.abs(zoneoffset);
      var currentSystemOffsetTemp = Math.abs(currentSystemOffset);
      if (zoneoffset > 0) {
        zoneoffset = zoneoffsetTemp - currentSystemOffsetTemp;
      } else {
        zoneoffset = zoneoffsetTemp + currentSystemOffsetTemp;
      }
    }
    var startTimeFullFormat = moment(startTime).tz(currentSystemTimezone).startOf("year").format("YYYY-MM-DD HH:mm:ss");
    var endTimeFullFormat = moment(endTime).tz(currentSystemTimezone).endOf("year").format("YYYY-MM-DD HH:mm:ss");
    var startTimeYear = moment(startTime).tz(currentSystemTimezone).startOf("year").format("YYY");
    if (zoneoffset >= 0) {
      startTimeFullFormat = moment(startTime).startOf("year").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).endOf("year").format("YYYY-MM-DD HH:mm:ss");
      startTimeYear = moment(startTime).startOf("year").format("YYYY");
      if (zoneoffset !== currentSystemOffset && zoneoffset < currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
        startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
      } else if (zoneoffset > currentSystemOffset) {
        startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
        endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
        startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
      }
    } else {
      zoneoffset = Math.abs(zoneoffset);
      startTimeFullFormat = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY-MM-DD HH:mm:ss");
      endTimeFullFormat = moment(endTime).add(zoneoffset, "minutes").endOf("year").format("YYYY-MM-DD HH:mm:ss");
      startTimeYear = moment(startTime).add(zoneoffset, "minutes").startOf("year").format("YYYY");
    }
    return {
      startTimeFullFormat: startTimeFullFormat,
      endTimeFullFormat: endTimeFullFormat,
      startTimeYear: startTimeYear
    };
  }
  React.useEffect(function () {
    var _convertOrganisationT = convertOrganisationTimezone(leaveYear, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
      startTimeFullFormat = _convertOrganisationT.startTimeFullFormat,
      endTimeFullFormat = _convertOrganisationT.endTimeFullFormat,
      startTimeYear = _convertOrganisationT.startTimeYear;
    setStartTime(startTimeFullFormat);
    setEndTime(endTimeFullFormat);
    //setYearFormatExport(startTimeYear);
  }, [leaveYear]);
  var _useQuery2 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery2.loading,
    userListData = _useQuery2.data,
    userListError = _useQuery2.error;
  var _useQuery3 = useQuery(LEAVE_DETAILS_FOR_STATUS_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
        leavePeriod: startDate ? moment(startDate).format("x") : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
        freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
        leaveFilterCheck: leaveFilterCheck && leaveFilterCheck.value ? leaveFilterCheck.value : null,
        leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove === void 0 ? void 0 : _leaveSettingsApprove.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
        leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove2 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove2 === void 0 ? void 0 : _leaveSettingsApprove2.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
        role: role
      }
    }),
    leaveCountData = _useQuery3.data,
    leaveCountError = _useQuery3.error,
    leaveCountLoading = _useQuery3.loading,
    leaveCountRefetch = _useQuery3.refetch;
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListingForLeave) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
    offsets = 0;
    leaveCountRefetch === null || leaveCountRefetch === void 0 ? void 0 : leaveCountRefetch();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ? /*#__PURE__*/React.createElement(LeaveManagementEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history,
    role: role
  }) : /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-listing-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "pending",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "admin-view-leave-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "pending",
    title: /*#__PURE__*/React.createElement("span", null, "Approval Pending Leave", " ", (leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave === void 0 ? void 0 : _leaveCountData$leave.pendingLeaveCount) != 0 && !leaveCountLoading && !leaveCountError ? "(".concat(leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave2 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave2 === void 0 ? void 0 : _leaveCountData$leave2.pendingLeaveCount, ")") : leaveCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    leaveFilterCheck: leaveFilterCheck,
    setleaveFilterCheck: setleaveFilterCheck,
    startTime: startTime,
    setStartTime: setStartTime,
    endTime: endTime,
    setEndTime: setEndTime,
    leaveYear: leaveYear,
    setLeaveYear: setLeaveYear,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    role: role
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    leaveFilterCheck: leaveFilterCheck,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    startTime: startTime,
    endTime: endTime,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    handleLeaveDetailsShow: handleLeaveDetailsShow,
    role: role
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "approved",
    title: /*#__PURE__*/React.createElement("span", null, "Approved Leave", " ", (leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave3 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave3 === void 0 ? void 0 : _leaveCountData$leave3.approvedLeaveCount) != 0 && !leaveCountLoading && !leaveCountError ? "(".concat(leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave4 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave4 === void 0 ? void 0 : _leaveCountData$leave4.approvedLeaveCount, ")") : leaveCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    leaveFilterCheck: leaveFilterCheck,
    setleaveFilterCheck: setleaveFilterCheck,
    startTime: startTime,
    setStartTime: setStartTime,
    endTime: endTime,
    setEndTime: setEndTime,
    leaveYear: leaveYear,
    setLeaveYear: setLeaveYear,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    role: role
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    leaveFilterCheck: leaveFilterCheck,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    startTime: startTime,
    endTime: endTime,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    handleLeaveDetailsShow: handleLeaveDetailsShow,
    role: role
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "rejected",
    title: /*#__PURE__*/React.createElement("span", null, "Rejected Leave", " ", (leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave5 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave5 === void 0 ? void 0 : _leaveCountData$leave5.rejectedLeaveCount) != 0 && !leaveCountLoading && !leaveCountError ? "(".concat(leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave6 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave6 === void 0 ? void 0 : _leaveCountData$leave6.rejectedLeaveCount, ")") : leaveCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    leaveFilterCheck: leaveFilterCheck,
    setleaveFilterCheck: setleaveFilterCheck,
    startTime: startTime,
    setStartTime: setStartTime,
    endTime: endTime,
    setEndTime: setEndTime,
    leaveYear: leaveYear,
    setLeaveYear: setLeaveYear,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    role: role
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    leaveFilterCheck: leaveFilterCheck,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    startTime: startTime,
    endTime: endTime,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    handleLeaveDetailsShow: handleLeaveDetailsShow,
    role: role
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "all",
    title: /*#__PURE__*/React.createElement("span", null, "All Leaves", " ", (leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave7 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave7 === void 0 ? void 0 : _leaveCountData$leave7.totalLeaveCount) != 0 && !leaveCountLoading && !leaveCountError ? "(".concat(leaveCountData === null || leaveCountData === void 0 ? void 0 : (_leaveCountData$leave8 = leaveCountData.leaveDetailsForStatusCount) === null || _leaveCountData$leave8 === void 0 ? void 0 : _leaveCountData$leave8.totalLeaveCount, ")") : leaveCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    leaveFilterCheck: leaveFilterCheck,
    setleaveFilterCheck: setleaveFilterCheck,
    startTime: startTime,
    setStartTime: setStartTime,
    endTime: endTime,
    setEndTime: setEndTime,
    leaveYear: leaveYear,
    setLeaveYear: setLeaveYear,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    role: role
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling,
    leaveFilterCheck: leaveFilterCheck,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    startTime: startTime,
    endTime: endTime,
    financialCheck: financialCheck,
    setFinancialCheck: setFinancialCheck,
    leaveStartTime: leaveStartTime,
    leaveEndTime: leaveEndTime,
    handleLeaveDetailsShow: handleLeaveDetailsShow,
    role: role
  })))))), /*#__PURE__*/React.createElement(LeaveDetailsModal, {
    leaveDetailsShow: leaveDetailsShow,
    handleLeaveDetailsClose: handleLeaveDetailsClose,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationId: organisationId,
    loginUserId: user.userId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    organisationBilling: organisationBilling
  }));
};
var ListData = [{
  label: "All Leaves",
  value: ""
}, {
  label: "Leave",
  value: "leave"
}, {
  label: "Short Leave",
  value: "short-leave"
}];
var TabFilter = function TabFilter(props) {
  var _leaveSettingsApprove5;
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    userListData = props.userListData,
    setStartDate = props.setStartDate,
    startDate = props.startDate,
    organisationBilling = props.organisationBilling,
    userListLoading = props.userListLoading,
    exportButton = props.exportButton,
    setExportButton = props.setExportButton,
    tabData = props.tabData,
    organisationId = props.organisationId,
    organisationTimezone = props.organisationTimezone,
    last14Days = props.last14Days,
    planName = props.planName,
    leaveFilterCheck = props.leaveFilterCheck,
    setleaveFilterCheck = props.setleaveFilterCheck,
    leaveYear = props.leaveYear,
    setLeaveYear = props.setLeaveYear,
    startTime = props.startTime,
    setStartTime = props.setStartTime,
    endTime = props.endTime,
    setEndTime = props.setEndTime,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    financialCheck = props.financialCheck,
    setFinancialCheck = props.setFinancialCheck,
    leaveStartTime = props.leaveStartTime,
    leaveEndTime = props.leaveEndTime,
    role = props.role;
  var _useLazyQuery = useLazyQuery(LEAVE_DETAILS_FOR_STATUS_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getLeaveDetailExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    leaveExportLoading = _useLazyQuery2$.loading,
    leaveExportData = _useLazyQuery2$.data;
  var getExportData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _leaveSettingsApprove3, _leaveSettingsApprove4;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setExportButton(true);
            getLeaveDetailExport({
              variables: {
                organisationId: organisationId,
                leaveStatus: tabData,
                userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                leavePeriod: startDate ? moment(startDate).format("x") : null,
                timeZone: organisationTimezone,
                freePlanStartDate: planName == "free" ? last14Days ? last14Days[0] : null : null,
                freePlanEndDate: planName == "free" ? last14Days ? last14Days[1] : null : null,
                leaveFilterCheck: leaveFilterCheck && leaveFilterCheck.value ? leaveFilterCheck.value : null,
                leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove3 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove3 === void 0 ? void 0 : _leaveSettingsApprove3.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
                leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove4 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove4 === void 0 ? void 0 : _leaveSettingsApprove4.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
                role: role
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getExportData() {
      return _ref.apply(this, arguments);
    };
  }();
  var csvLeaveData = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(leavePeriodDate) {
      var dataArray, dataValues, wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dataArray = [];
            dataValues = leaveExportData === null || leaveExportData === void 0 ? void 0 : leaveExportData.leaveDetailsForStatusExport;
            if (dataValues) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", []);
          case 4:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            if (tabData == "all") {
              ws.columns = [{
                header: "Employee Name",
                key: "user",
                width: 20,
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Period",
                key: "leavePeriod",
                width: 10,
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Days",
                key: "days",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Type",
                key: "type",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Category",
                key: "leaveCategory",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Applied On",
                key: "appliedOn",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Status",
                key: "status",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Reason",
                key: "leaveReason",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }];
            } else {
              ws.columns = [{
                header: "Employee Name",
                key: "user",
                width: 20,
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Period",
                key: "leavePeriod",
                width: 10,
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Days",
                key: "days",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Type",
                key: "type",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Category",
                key: "leaveCategory",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Applied On",
                key: "appliedOn",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }, {
                header: "Leave Reason",
                key: "leaveReason",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              }];
            }
            dataValues.map(function (d, index) {
              var leaveType = d.leaveType,
                leaveStartDate = d.leaveStartDate,
                leaveEndDate = d.leaveEndDate,
                leaveDays = d.leaveDays,
                leaveReason = d.leaveReason,
                appliedAt = d.appliedAt,
                user = d.user,
                appliedStatus = d.appliedStatus,
                leaveStartDateFormat = d.leaveStartDateFormat,
                leaveEndDateFormat = d.leaveEndDateFormat,
                attendanceType = d.attendanceType,
                leaveCategory = d.leaveCategory;
              var displayName = user.displayName;
              var leaveDate = leaveEndDate ? "".concat(leaveStartDateFormat, " - ").concat(leaveEndDateFormat) : leaveStartDateFormat;
              var leaveDaysTemp = attendanceType == "permission" ? leaveDays : Number(leaveDays) > 1 ? "".concat(leaveDays, " Days") : "".concat(leaveDays, " Day");
              var applieOnTemp = moment(appliedAt).format("DD MMM YYYY");
              ws.addRow({
                user: displayName,
                leavePeriod: leaveDate,
                days: leaveDaysTemp,
                type: leaveType,
                leaveCategory: leaveCategory,
                appliedOn: applieOnTemp,
                status: tabData == "all" ? appliedStatus : "",
                leaveReason: decodeHtmlEntities(leaveReason)
              });
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            ws.getCell("C1").font = {
              bold: true
            };
            ws.getCell("D1").font = {
              bold: true
            };
            ws.getCell("E1").font = {
              bold: true
            };
            ws.getCell("F1").font = {
              bold: true
            };
            ws.getCell("G1").font = {
              bold: true
            };
            ws.getCell("G1").font = {
              bold: true
            };
            _context2.next = 18;
            return wb.xlsx.writeBuffer();
          case 18:
            buf = _context2.sent;
            fileName = "workfolio-".concat(tabData != "all" ? "".concat(tabData, "-") : "", "leave").concat(leavePeriodDate ? "-".concat(moment(leavePeriodDate).format("DD-MMM")) : "", ".xlsx");
            saveAs(new Blob([buf]), fileName);
            setExportButton(false);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [leaveExportData]);

  //dynamic finacial year generation
  var financialYearList = [{
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(3, "year").format("YYYY") : moment().subtract(2, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(3, "year").format("YYYY") : moment().subtract(2, "year").format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().subtract(0, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(2, "year").format("YYYY") : moment().subtract(1, "year").format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().subtract(1, "year").format("YYYY") : moment().format("YYYY"))
  }, {
    label: "Apr ".concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY"), " - Mar ").concat(moment().format("M") <= 3 ? moment().add(1, "year").format("YYYY") : moment().add(2, "year").format("YYYY")),
    value: "".concat(moment().format("M") <= 3 ? moment().format("YYYY") : moment().add(1, "year").format("YYYY"))
  }];
  React.useEffect(function () {
    csvLeaveData(startDate);
  }, [leaveExportData]);
  return /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-content"
  }, userListLoading ? /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-user-tab-filter"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userListData,
    className: "daily-attendance-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: leaveFilterCheck,
    onChange: function onChange(e) {
      return setleaveFilterCheck(e);
    },
    options: ListData,
    className: "daily-attendance-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-date-picker admin-view-leave-date-picker-manage-leave"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove5 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove5 === void 0 ? void 0 : _leaveSettingsApprove5.leaveYearSettings) !== "financial-year" ? /*#__PURE__*/React.createElement(DatePicker, {
    selected: leaveYear,
    onChange: function onChange(date) {
      return setLeaveYear(date);
    },
    showYearPicker: true,
    dateFormat: "yyyy"
    //minDate={organisationBilling?.planName == "free" ? subDays(new Date(), 14) : null}
    ,
    className: "leave-picker",
    placeholderText: "Select Leave Period"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "leave-history-date-picker-finacial"
  }, /*#__PURE__*/React.createElement(Select, {
    value: financialCheck,
    onChange: function onChange(e) {
      return setFinancialCheck(e);
    },
    options: financialYearList,
    className: "leave-history-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    placeholder: "Select Year",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  })) : null)), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))));
};
var TabData = function TabData(props) {
  var _leaveSettingsApprove6, _leaveSettingsApprove7, _leaveSettingsApprove8, _leaveSettingsApprove9, _leaveDetails$leaveDe10;
  var tabData = props.tabData,
    userParameterCheck = props.userParameterCheck,
    leavePeriodDate = props.leavePeriodDate,
    organisationTimezone = props.organisationTimezone,
    organisationId = props.organisationId,
    reviewedLeaveList = props.reviewedLeaveList,
    setReviewedLeaveList = props.setReviewedLeaveList,
    last14Days = props.last14Days,
    planName = props.planName,
    organisationBilling = props.organisationBilling,
    leaveFilterCheck = props.leaveFilterCheck,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    startTime = props.startTime,
    endTime = props.endTime,
    financialCheck = props.financialCheck,
    setFinancialCheck = props.setFinancialCheck,
    leaveStartTime = props.leaveStartTime,
    leaveEndTime = props.leaveEndTime,
    handleLeaveDetailsShow = props.handleLeaveDetailsShow,
    role = props.role;
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isPendingLoaded = _React$useState22[0],
    setIsPendingLoaded = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isPendingLoadingMore = _React$useState24[0],
    setIsPendingLoadingMore = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isApprovedLoaded = _React$useState26[0],
    setIsApprovedLoaded = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isApprovedLoadingMore = _React$useState28[0],
    setIsApprovedLoadingMore = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    isRejectedLoaded = _React$useState30[0],
    setIsRejectedLoaded = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    isRejectedLoadingMore = _React$useState32[0],
    setIsRejectedLoadingMore = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isAllLoaded = _React$useState34[0],
    setIsAllLoaded = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    isLoadingMore = _React$useState36[0],
    setIsLoadingMore = _React$useState36[1];
  var hasFetchedMoreRef = React.useRef(false);
  var _React$useState37 = React.useState(null),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    changeLeaveStatusModal = _React$useState38[0],
    setChangeLeaveStatusModal = _React$useState38[1];
  var _React$useState39 = React.useState(null),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    deleteLeaveModal = _React$useState40[0],
    setDeleteLeaveModal = _React$useState40[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    deleteLeaveData = _useState6[0],
    setDeleteLeaveData = _useState6[1];
  var _React$useState41 = React.useState(""),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    reasonText = _React$useState42[0],
    setReasonText = _React$useState42[1];
  var _React$useState43 = React.useState(""),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    errorText = _React$useState44[0],
    setErrorText = _React$useState44[1];
  var _React$useState45 = React.useState(""),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    deleteErrorText = _React$useState46[0],
    setDeleteErrorText = _React$useState46[1];
  var handleChangeLeaveStatusClose = function handleChangeLeaveStatusClose() {
    setChangeLeaveStatusModal(false);
    setReasonText("");
    setErrorText("");
  };
  var handleChangeLeaveStatusShow = function handleChangeLeaveStatusShow(list) {
    setChangeLeaveStatusModal(list);
  };
  var handleDeleteLeaveModalClose = function handleDeleteLeaveModalClose() {
    setDeleteLeaveModal(false);
    setDeleteErrorText("");
  };
  var handleDeleteLeaveModalShow = function handleDeleteLeaveModalShow(list) {
    setDeleteLeaveModal(list);
  };

  // Drop the deleted leave from the cached list so the next "Load more" offset
  // matches the server, which no longer counts the deleted row.
  var removeLeaveFromList = function removeLeaveFromList(deletedLeaveId) {
    var remainingCount = ((leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.leaveDetailsForStatus) || []).filter(function (item) {
      return item.leaveId !== deletedLeaveId;
    }).length;

    // Every loaded row was deleted, but the server may still have more leaves
    // beyond this page. Reload the first page instead of showing the empty state.
    if (remainingCount === 0) {
      setIsPendingLoaded(false);
      setIsAllLoaded(false);
      setIsApprovedLoaded(false);
      setIsRejectedLoaded(false);
      hasFetchedMoreRef.current = false;
      leaveDetailsRefetch === null || leaveDetailsRefetch === void 0 ? void 0 : leaveDetailsRefetch();
      return;
    }

    // The shrunken list length no longer reflects the page size, so keep the
    // length-based effect below from marking the tab as fully loaded.
    hasFetchedMoreRef.current = true;
    updateLeaveDetails(function (prev) {
      if (!(prev !== null && prev !== void 0 && prev.leaveDetailsForStatus)) return prev;
      return _objectSpread(_objectSpread({}, prev), {}, {
        leaveDetailsForStatus: prev.leaveDetailsForStatus.filter(function (item) {
          return item.leaveId !== deletedLeaveId;
        })
      });
    });
  };
  var _useQuery4 = useQuery(LEAVE_DETAILS_FOR_STATUS_QUERY, {
      variables: {
        organisationId: organisationId,
        leaveStatus: tabData,
        userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
        leavePeriod: leavePeriodDate ? moment(leavePeriodDate).format("x") : null,
        timeZone: organisationTimezone,
        limit: LIMIT,
        offset: 0,
        freePlanStartDate: planName == "free" ? last14Days ? last14Days[0] : null : null,
        freePlanEndDate: planName == "free" ? last14Days ? last14Days[1] : null : null,
        leaveFilterCheck: leaveFilterCheck && leaveFilterCheck.value ? leaveFilterCheck.value : null,
        leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove6 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove6 === void 0 ? void 0 : _leaveSettingsApprove6.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
        leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove7 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove7 === void 0 ? void 0 : _leaveSettingsApprove7.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
        role: role
      },
      skip: !organisationId
    }),
    leaveDetailsLoading = _useQuery4.loading,
    leaveDetails = _useQuery4.data,
    leaveDetailsError = _useQuery4.error,
    fetchMore = _useQuery4.fetchMore,
    leaveDetailsRefetch = _useQuery4.refetch,
    updateLeaveDetails = _useQuery4.updateQuery;
  React.useEffect(function () {
    setIsPendingLoaded(false);
    setIsAllLoaded(false);
    setIsApprovedLoaded(false);
    setIsRejectedLoaded(false);
    hasFetchedMoreRef.current = false;
    leaveDetailsRefetch === null || leaveDetailsRefetch === void 0 ? void 0 : leaveDetailsRefetch();
  }, [tabData, userParameterCheck, leavePeriodDate, leaveSettingsApprovedData, startTime, leaveStartTime, endTime, leaveEndTime]);

  // React.useEffect(() => {
  //   console.log("leave enter");
  //   console.log({ tabData });
  //   leaveDetailsRefetch?.();
  // }, [tabData]);

  React.useEffect(function () {
    // Once pagination has started, `leaveDetailsForStatus` holds the cumulative
    // merged list, not the latest page, so its length can no longer tell us
    // whether more data remains. After that point, `handleLoadMore`'s
    // `updateQuery` is the sole source of truth for the "loaded" flags.
    if (hasFetchedMoreRef.current) return;
    if (tabData === "pending") {
      var _leaveDetails$leaveDe, _leaveDetails$leaveDe2;
      setIsPendingLoaded((leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe === void 0 ? void 0 : _leaveDetails$leaveDe.length) != 0 && (leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe2 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe2 === void 0 ? void 0 : _leaveDetails$leaveDe2.length) < LIMIT && !isPendingLoaded ? true : false);
    } else if (tabData === "all") {
      var _leaveDetails$leaveDe3, _leaveDetails$leaveDe4;
      setIsAllLoaded((leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe3 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe3 === void 0 ? void 0 : _leaveDetails$leaveDe3.length) != 0 && (leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe4 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe4 === void 0 ? void 0 : _leaveDetails$leaveDe4.length) < LIMIT && !isAllLoaded ? true : false);
    } else if (tabData === "approved") {
      var _leaveDetails$leaveDe5, _leaveDetails$leaveDe6;
      setIsApprovedLoaded((leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe5 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe5 === void 0 ? void 0 : _leaveDetails$leaveDe5.length) != 0 && (leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe6 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe6 === void 0 ? void 0 : _leaveDetails$leaveDe6.length) < LIMIT && !isApprovedLoaded ? true : false);
    } else if (tabData === "rejected") {
      var _leaveDetails$leaveDe7, _leaveDetails$leaveDe8;
      setIsRejectedLoaded((leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe7 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe7 === void 0 ? void 0 : _leaveDetails$leaveDe7.length) != 0 && (leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe8 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe8 === void 0 ? void 0 : _leaveDetails$leaveDe8.length) < LIMIT && !isRejectedLoaded ? true : false);
    }
  }, [leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.leaveDetailsForStatus]);
  if (leaveDetailsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (leaveDetailsError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!leaveDetails) {
    return null;
  }
  var handleLoadMore = function handleLoadMore() {
    var _leaveDetails$leaveDe9;
    if (leaveDetailsLoading) return;
    hasFetchedMoreRef.current = true;
    if (tabData === "pending") {
      setIsPendingLoadingMore(true);
    } else if (tabData === "all") {
      setIsLoadingMore(true);
    } else if (tabData === "approved") {
      setIsApprovedLoadingMore(true);
    } else if (tabData === "rejected") {
      setIsRejectedLoadingMore(true);
    }
    fetchMore({
      variables: {
        offset: leaveDetails === null || leaveDetails === void 0 ? void 0 : (_leaveDetails$leaveDe9 = leaveDetails.leaveDetailsForStatus) === null || _leaveDetails$leaveDe9 === void 0 ? void 0 : _leaveDetails$leaveDe9.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveDetailsForStatus.length) < LIMIT && (!isPendingLoaded || !isAllLoaded || !isApprovedLoaded || !isRejectedLoaded)) {
          if (tabData === "pending") {
            setIsPendingLoaded(true);
          } else if (tabData === "all") {
            setIsAllLoaded(true);
          } else if (tabData === "approved") {
            setIsApprovedLoaded(true);
          } else if (tabData === "rejected") {
            setIsRejectedLoaded(true);
          }
        }
        if (tabData === "pending") {
          setIsPendingLoadingMore(false);
        } else if (tabData === "all") {
          setIsLoadingMore(false);
        } else if (tabData === "approved") {
          setIsApprovedLoadingMore(false);
        } else if (tabData === "rejected") {
          setIsRejectedLoadingMore(false);
        }
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveDetailsForStatus.length) > 0) {
          var NewFilterData = [];
          fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveDetailsForStatus.forEach(function (newLeave) {
            var found = prev === null || prev === void 0 ? void 0 : prev.leaveDetailsForStatus.find(function (item) {
              return item.leaveId === newLeave.leaveId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newLeave);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            leaveDetailsForStatus: [].concat(_toConsumableArray(prev.leaveDetailsForStatus), NewFilterData)
          });
        }
        return prev;
      }
    });
  };
  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(organisationTimezone).utcOffset();
  return /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-listing-tab-Content"
  }, (leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.leaveDetailsForStatus.length) !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "admin-view-leave-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "admin-view-leave-ta-contents-header"
  }, /*#__PURE__*/React.createElement("th", null, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Leave Period"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, "Leave Type"), /*#__PURE__*/React.createElement("th", null, " Category"), /*#__PURE__*/React.createElement("th", null, " Applied On"), tabData == "approved" || tabData == "rejected" ? /*#__PURE__*/React.createElement("th", null, tabData == "approved" ? "Approved by" : "Rejected by") : null, tabData == "all" ? /*#__PURE__*/React.createElement("th", null, "Status") : null, /*#__PURE__*/React.createElement("th", null, "Reason"), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" ? /*#__PURE__*/React.createElement("th", null, "Files") : null, tabData == "pending" ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", {
    className: "admin-view-leave-table-body"
  }, leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.leaveDetailsForStatus.map(function (list, index) {
    var leaveId = list.leaveId,
      userId = list.userId,
      leaveType = list.leaveType,
      leaveStartDate = list.leaveStartDate,
      leaveEndDate = list.leaveEndDate,
      leaveDays = list.leaveDays,
      leaveReason = list.leaveReason,
      appliedAt = list.appliedAt,
      appliedStatus = list.appliedStatus,
      user = list.user,
      statusModifyDisplayName = list.statusModifyDisplayName,
      leaveRejectReason = list.leaveRejectReason,
      leaveStartDateFormat = list.leaveStartDateFormat,
      leaveEndDateFormat = list.leaveEndDateFormat,
      attendanceType = list.attendanceType,
      permissionTypeId = list.permissionTypeId,
      permissionStartTime = list.permissionStartTime,
      permissionEndTime = list.permissionEndTime,
      dateDetails = list.dateDetails,
      leaveCategory = list.leaveCategory,
      isAdmin = list.isAdmin,
      leaveAttachments = list.leaveAttachments,
      leaveTypeDeleted = list.leaveTypeDeleted,
      leaveTypeArchive = list.leaveTypeArchive;
    if (tabData == "all" && deleteLeaveData.length > 0 && deleteLeaveData.includes(leaveId)) {
      return;
    }
    var findLeaveStatusDetails = reviewedLeaveList && reviewedLeaveList.find(function (leave) {
      return leave.leaveId === leaveId;
    }) || {};
    var approvedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "approved" ? true : false;
    var approvedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;
    var rejectedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "rejected" ? true : false;
    var rejectedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;

    /* offset check */

    var startValueFormate = moment.unix(leaveStartDate / 1000).format("DD MMM, yyyy");
    var endValueFormate = leaveEndDate ? moment.unix(leaveEndDate / 1000).format("DD MMM, yyyy") : null;
    if (zoneoffset !== currentSystemOffset) {
      startValueFormate = convertOrganisationTimezones(moment(Number(leaveStartDate)).format("YYYY-MM-DD HH:mm:ss"), 0, organisationTimezone);
      if (leaveEndDate) {
        endValueFormate = convertOrganisationTimezones(moment(Number(leaveEndDate)).format("YYYY-MM-DD HH:mm:ss"), 0, organisationTimezone);
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "admin-view-leave-listing-tab-Content-list"
    }, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-displayName",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-avatar"
    }, user !== null && user !== void 0 && user.profileUrl ? /*#__PURE__*/React.createElement("div", {
      "class": "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      "class": "admin-view-leave-team-card-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-avatar-circle text-white"
    }, user === null || user === void 0 ? void 0 : user.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-name-data-team-name-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, user === null || user === void 0 ? void 0 : user.displayName)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/personal-statistics/".concat(user === null || user === void 0 ? void 0 : user.uniqueUrl)
    }, /*#__PURE__*/React.createElement("span", {
      "class": "admin-view-leave-card-table-list-name"
    }, user === null || user === void 0 ? void 0 : user.displayName))))))), attendanceType == "permission" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-date",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, leaveStartDateFormat, " ", /*#__PURE__*/React.createElement("span", {
      className: "short-leave-history-time"
    }, "(", moment.unix(permissionStartTime / 1000).format("hh:mm A"), " -", " ", moment.unix(permissionEndTime / 1000).format("hh:mm A"), ")")) : /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-date",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, leaveEndDate ? "".concat(leaveStartDateFormat, " - ").concat(leaveEndDateFormat) : leaveStartDateFormat), /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-dates-count",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-listing-tab-tab-Content-list-dates-count-span"
    }, attendanceType == "permission" ? leaveDays : Number(leaveDays) > 1 ? "".concat(leaveDays, " Days") : "".concat(leaveDays, " Day")), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "view-leave-balanace-tooltip-start"
      }, attendanceType == "permission" ? /*#__PURE__*/React.createElement("div", {
        className: "view-leave-balanace-count-tooltip-user-content view-leave-balanace-tooltip-start-span"
      }, "(", moment.unix(permissionStartTime / 1000).format("hh:mm A"), " -", " ", moment.unix(permissionEndTime / 1000).format("hh:mm A"), ")") : /*#__PURE__*/React.createElement("div", {
        className: "view-leave-balanace-count-tooltip-user-content"
      }, dateDetails.map(function (dateValue) {
        return /*#__PURE__*/React.createElement("div", {
          className: "view-leave-balanace-count-tooltip-user-content-div"
        }, /*#__PURE__*/React.createElement("span", null, dateValue.dateFormatTooltip, ": "), /*#__PURE__*/React.createElement("span", {
          className: "view-leave-balanace-tooltip-start-span"
        }, dateValue.dayType == "full-day" ? "Full Day" : dateValue.dayType == "half-day-first-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-first-half" ? "Half day - 1st Half" : dateValue.dayType == "half-day-second-half" || dateValue.dayType == "non-working-day" && dateValue.nonWorkingDayLeaveSession == "half-day-second-half" ? "Half day - 2nd Half" : dateValue.dayType == "non-working-day" && (dateValue.nonWorkingDayLeaveSession == "full-day" || dateValue.nonWorkingDayLeaveSession == null) ? "Non Working Day" : null));
      })))
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-listing-tab-tab-Content-list-dates-count-span-icon"
    }, /*#__PURE__*/React.createElement(MdInfoOutline, null)))), /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-type leave-summary-user-leave-details-leave-type ",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "view-leave-balanace-tooltip-start"
      }, leaveType.replace(/-/g, " "))
    }, /*#__PURE__*/React.createElement("div", {
      className: "admin-view-leave-type-listed"
    }, leaveType.replace(/-/g, " ")))), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "header-admin-view-leave-width"
    }, leaveCategory)), /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-on",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, moment.unix(appliedAt / 1000).format("DD MMM, yyyy")), tabData == "approved" || tabData == "rejected" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : "", appliedStatus == "rejected" && leaveRejectReason ? /*#__PURE__*/React.createElement("div", null, "Rejection Reason : ", decodeHtmlEntities(leaveRejectReason)) : null))
    }, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-all-by-text-all",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, statusModifyDisplayName !== null ? statusModifyDisplayName : "")) : null, tabData == "all" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-all-by-text admin-view-leave-card-table-list-status-td-text admin-view-leave-card-table-list-status-td-text-".concat(appliedStatus),
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, appliedStatus == "pending" ? "Pending Approval" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : "", appliedStatus == "rejected" && leaveRejectReason ? /*#__PURE__*/React.createElement("div", null, "Rejection Reason : ", leaveRejectReason) : null))
    }, /*#__PURE__*/React.createElement("span", null, appliedStatus == "pending" ? "Pending Approval" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : ""))) : null, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-info",
      onClick: function onClick() {
        return handleLeaveDetailsShow(list);
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, decodeHtmlEntities(leaveReason)))
    }, /*#__PURE__*/React.createElement("span", {
      className: "admin-view-listing-tab-tab-Content-list-dates-text"
    }, decodeHtmlEntities(leaveReason)))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-attachment"
    }, leaveAttachments && leaveAttachments.length > 0 ? leaveAttachments.map(function (attachment) {
      return /*#__PURE__*/React.createElement("a", {
        key: attachment.attachmentId,
        href: attachment.attachmentUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "admin-view-leave-attachment-link"
      }, /*#__PURE__*/React.createElement(FaRegFilePdf, {
        className: "admin-view-leave-attachment-icon"
      }), /*#__PURE__*/React.createElement("u", null, "View"));
    }) : /*#__PURE__*/React.createElement("span", {
      className: "admin-view-leave-attachment-empty"
    }, "-")) : null, tabData == "pending" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-list-status-td"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: leaveTypeDeleted ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "approve-restricted-tooltip"
      }, "This leave type is deleted, so you can't approve or reject it.") : leaveTypeArchive == "archived" ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "archived-restricted-tooltip"
      }, "Admin modified the leave type, so you can't approve or reject it.") : role != "Admin" && isAdmin ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "approve-restricted-tooltip"
      }, "This is an admin leave request; you cannot approve or reject it.") : /*#__PURE__*/React.createElement("span", null)
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
      variant: approvedStatusCheck ? "success" : "outline-success",
      className: "rounded-pill admin-view-leave-reviewed-button",
      size: "sm",
      onClick: function onClick() {
        if (!leaveTypeDeleted && leaveTypeArchive != "archived" && !approvedStatusCheckForDisable && !approvedStatusCheck && (role == "Admin" || !isAdmin)) {
          handleChangeLeaveStatusShow({
            leaveId: leaveId,
            leaveStatus: "approved",
            userId: user.userId,
            attendanceType: attendanceType
          });
        }
      },
      disabled: leaveTypeDeleted || leaveTypeArchive == "archived" || approvedStatusCheckForDisable || approvedStatusCheck || role != "Admin" && isAdmin
    }, approvedStatusCheck ? "Approved" : "Approve"))), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: leaveTypeDeleted ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "reject-restricted-tooltip"
      }, "This leave type is deleted, so you can't approve or reject it.") : leaveTypeArchive == "archived" ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "archived-restricted-tooltip"
      }, "Admin modified the leave type, so you can't approve or reject it.") : role != "Admin" && isAdmin ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "reject-restricted-tooltip"
      }, "This is an admin leave request; you cannot approve or reject it.") : /*#__PURE__*/React.createElement("span", null)
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
      variant: rejectedStatusCheck ? "danger" : "outline-danger",
      className: "rounded-pill admin-view-leave-reviewed-button",
      size: "sm",
      onClick: function onClick() {
        if (!leaveTypeDeleted && leaveTypeArchive != "archived" && !rejectedStatusCheckForDisable && !rejectedStatusCheck && (role == "Admin" || !isAdmin)) {
          handleChangeLeaveStatusShow({
            leaveId: leaveId,
            leaveStatus: "rejected",
            userId: user.userId,
            attendanceType: attendanceType
          });
        }
      },
      disabled: leaveTypeDeleted || leaveTypeArchive == "archived" || rejectedStatusCheckForDisable || rejectedStatusCheck || role != "Admin" && isAdmin
    }, rejectedStatusCheck ? "Rejected" : "Reject")))) : tabData == "all" ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "admin-view-listing-tab-tab-Content-table-data-icon-whole-div"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: leaveTypeDeleted ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "delete-restricted-tooltip"
      }, "This leave type is deleted, so you can't delete it.") : leaveTypeArchive == "archived" ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "archived-restricted-tooltip"
      }, "Admin modified the leave type, so you can't delete it.") : role != "Admin" && isAdmin ? /*#__PURE__*/React.createElement(Tooltip, {
        id: "delete-restricted-tooltip"
      }, "This is an admin leave request; you cannot delete it.") : /*#__PURE__*/React.createElement("span", null)
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
      className: "admin-view-listing-tab-tab-Content-table-data-icon-div",
      onClick: function onClick() {
        if (!leaveTypeDeleted && leaveTypeArchive != "archived" && !(role != "Admin" && isAdmin)) {
          handleDeleteLeaveModalShow(list);
        }
      },
      style: leaveTypeDeleted || leaveTypeArchive == "archived" || role != "Admin" && isAdmin ? {
        pointerEvents: "none",
        opacity: 0.5
      } : {}
    }, /*#__PURE__*/React.createElement(MdDeleteForever, {
      className: "admin-view-listing-tab-tab-Content-table-data-edit-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "admin-view-listing-tab-tab-Content-table-data-edit-text"
    }, "Delete")))))) : null));
  })))) : planName == "free" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "You have no leaves to show", " ", /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext-free-text"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data."))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, " ", tabData === "all" ? "You have no leave requests for ".concat((leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove8 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove8 === void 0 ? void 0 : _leaveSettingsApprove8.leaveYearSettings) !== "financial-year" ? moment(startTime).year() : financialCheck.label) : "You have no ".concat(tabData, " leave requests for ").concat((leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove9 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove9 === void 0 ? void 0 : _leaveSettingsApprove9.leaveYearSettings) !== "financial-year" ? moment(startTime).year() : financialCheck.label, " ")), leaveDetails !== null && leaveDetails !== void 0 && (_leaveDetails$leaveDe10 = leaveDetails.leaveDetailsForStatus) !== null && _leaveDetails$leaveDe10 !== void 0 && _leaveDetails$leaveDe10.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isPendingLoaded && tabData === "pending" || !isAllLoaded && tabData === "all" || !isApprovedLoaded && tabData === "approved" || !isRejectedLoaded && tabData === "rejected" ? /*#__PURE__*/React.createElement(React.Fragment, null, isPendingLoadingMore && tabData === "pending" || isLoadingMore && tabData === "all" || isApprovedLoadingMore && tabData === "approved" || isRejectedLoadingMore && tabData === "rejected" ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : planName == "free" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext-free-text"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data.") : /*#__PURE__*/React.createElement("p", {
    className: "project-task-tracket-all-task-label"
  }, "You have seen all the leaves")) : null, /*#__PURE__*/React.createElement(LeaveStatusChangeModal, {
    changeLeaveStatusModal: changeLeaveStatusModal,
    handleChangeLeaveStatusClose: handleChangeLeaveStatusClose,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    organisationTimezone: organisationTimezone,
    planName: planName,
    setReasonText: setReasonText,
    reasonText: reasonText,
    setErrorText: setErrorText,
    errorText: errorText
  }), /*#__PURE__*/React.createElement(DeleteConfirmation, {
    show: deleteLeaveModal,
    handleDeleteLeaveModalClose: handleDeleteLeaveModalClose,
    organisationTimezone: organisationTimezone,
    organisationId: organisationId,
    deleteLeaveData: deleteLeaveData,
    setDeleteLeaveData: setDeleteLeaveData,
    removeLeaveFromList: removeLeaveFromList,
    userParameterCheck: userParameterCheck,
    startDate: leavePeriodDate,
    last14Days: last14Days,
    organisationBilling: organisationBilling,
    leaveFilterCheck: leaveFilterCheck,
    setDeleteErrorText: setDeleteErrorText,
    deleteErrorText: deleteErrorText,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    startTime: startTime,
    leaveStartTime: leaveStartTime,
    endTime: endTime,
    leaveEndTime: leaveEndTime,
    role: role
  }));
};
var LeaveDetailsModal = function LeaveDetailsModal(props) {
  var leaveDetailsShow = props.leaveDetailsShow,
    handleLeaveDetailsClose = props.handleLeaveDetailsClose,
    organisationTimezone = props.organisationTimezone,
    planName = props.planName,
    organisationId = props.organisationId,
    loginUserId = props.loginUserId,
    reviewedLeaveList = props.reviewedLeaveList,
    setReviewedLeaveList = props.setReviewedLeaveList,
    organisationBilling = props.organisationBilling;
  if (!leaveDetailsShow) {
    return null;
  }
  var leaveId = leaveDetailsShow.leaveId,
    leaveStatus = leaveDetailsShow.leaveStatus,
    userId = leaveDetailsShow.userId,
    attendanceType = leaveDetailsShow.attendanceType,
    user = leaveDetailsShow.user,
    leaveDays = leaveDetailsShow.leaveDays,
    leaveType = leaveDetailsShow.leaveType,
    leaveCategory = leaveDetailsShow.leaveCategory,
    leaveReason = leaveDetailsShow.leaveReason,
    appliedAt = leaveDetailsShow.appliedAt,
    leaveStartDateFormat = leaveDetailsShow.leaveStartDateFormat,
    leaveEndDateFormat = leaveDetailsShow.leaveEndDateFormat,
    appliedStatus = leaveDetailsShow.appliedStatus,
    leaveAttachments = leaveDetailsShow.leaveAttachments,
    leaveTypeDeleted = leaveDetailsShow.leaveTypeDeleted,
    leaveTypeArchive = leaveDetailsShow.leaveTypeArchive;
  var reviewRestrictedText = leaveTypeDeleted ? "This leave type is deleted, so you can't approve or reject it." : leaveTypeArchive == "archived" ? "Admin modified the leave type, so you can't approve or reject it." : null;
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    leaveTypeChange = _useState8[0],
    setLeaveTypeChange = _useState8[1];
  var _useMutation = useMutation(UPDATE_LEAVE_STATUS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateLeaveStatus = _useMutation2[0],
    updateLeaveStatusLoading = _useMutation2[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(leaveId, leaveStatus) {
      var leaveResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!updateLeaveStatusLoading) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return updateLeaveStatus({
              variables: {
                organisationId: organisationId,
                leaveId: leaveId,
                leaveStatus: leaveStatus,
                timeZone: organisationTimezone,
                userId: user.userId,
                rejectedReasonText: null,
                freePlanStatus: planName,
                attendanceType: attendanceType
              }
            });
          case 5:
            leaveResponse = _context3.sent;
            if (!leaveResponse || !leaveResponse.data || leaveResponse.data.updateLeaveStatus == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              setReviewedLeaveList(function (oldLeave) {
                return [].concat(_toConsumableArray(oldLeave), [{
                  leaveId: leaveId,
                  leaveStatus: leaveStatus
                }]);
              });
              handleLeaveDetailsClose();
              toast.success("Leave ".concat(leaveStatus, " successfully!"));
              setReasonText("");
            }
            _context3.next = 13;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            if (_context3.t0.message == "Some of your employees are changed the status") {
              setErrorText("Something went wrong, Pls refresh the page");
            }
            console.log(_context3.t0);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9]]);
    }));
    return function (_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [updateLeaveStatus, updateLeaveStatusLoading, reviewedLeaveList]);
  var findLeaveStatusDetails = reviewedLeaveList && reviewedLeaveList.find(function (leave) {
    return leave.leaveId === leaveId;
  }) || {};
  var approvedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "approved" ? true : false;
  var approvedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;
  var rejectedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "rejected" ? true : false;
  var rejectedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;
  function decodeHtmlEntities(str) {
    var parser = new DOMParser();
    var decoded = parser.parseFromString(str, "text/html").body.textContent;
    return decoded;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: leaveDetailsShow,
    onHide: handleLeaveDetailsClose,
    centered: true,
    size: "md",
    className: "leave-details-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 align-items-center"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("span", null, "Leave Details")), /*#__PURE__*/React.createElement("span", {
    className: "badge ".concat(appliedStatus == "pending" && !approvedStatusCheck && !rejectedStatusCheck ? "badge-warning" : appliedStatus == "approved" || approvedStatusCheck ? "badge-success" : "badge-danger", " text-capitalize ml-auto")
  }, approvedStatusCheck ? "Approved" : rejectedStatusCheck ? "Rejected" : appliedStatus))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-4 leave-details-modal-body-text"
  }, "Review and manage leave application"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, user.profileUrl ? /*#__PURE__*/React.createElement("div", {
    "class": "employee-card-avatar-profile"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: user === null || user === void 0 ? void 0 : user.profileUrl,
    "class": "admin-view-leave-team-card-avatar-profile-img"
  })) : /*#__PURE__*/React.createElement(FaUserCircle, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Employee Name"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, user.displayName))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaRegCalendar, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Leave Period"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, leaveEndDateFormat ? "".concat(leaveStartDateFormat, " - ").concat(leaveEndDateFormat) : leaveStartDateFormat)))), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaRegClock, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Duration"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, leaveDays, Number(leaveDays) > 1 ? " days" : " day")))), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FiTag, {
    className: "text-success mr-3 mt-2 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Leave Type"), /*#__PURE__*/React.createElement("p", {
    className: "mb-0 leave-details-modal-body-value"
  }, leaveType)))), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaRegFileAlt, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Category"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, leaveCategory)))), /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(AiOutlineExclamationCircle, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Leave Reason"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, decodeHtmlEntities(leaveReason))))), /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaRegCalendar, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Applied Date"), /*#__PURE__*/React.createElement("span", {
    className: "leave-details-modal-body-value"
  }, moment(appliedAt).format("DD/MM/yyyy"))))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && leaveAttachments && leaveAttachments.length > 0 && /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement(FaRegFilePdf, {
    className: "text-success mr-3 mt-1 leave-details-modal-body-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted mb-2"
  }, "Attachment(s)"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap",
    style: {
      gap: "10px"
    }
  }, leaveAttachments.map(function (attachment) {
    return /*#__PURE__*/React.createElement("a", {
      key: attachment.attachmentId,
      href: attachment.attachmentUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "admin-view-leave-modal-attachment-link"
    }, /*#__PURE__*/React.createElement(FaRegFilePdf, {
      className: "admin-view-leave-modal-attachment-file-icon"
    }), /*#__PURE__*/React.createElement("u", null, "View"));
  }))))))), leaveDetailsShow.appliedStatus == "pending" ? /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: reviewRestrictedText ? /*#__PURE__*/React.createElement(Tooltip, {
      id: "modal-approve-restricted-tooltip"
    }, reviewRestrictedText) : /*#__PURE__*/React.createElement("span", null)
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-success",
    className: "px-4 ml-2 rounded-pill leave-details-modal-footer-button"
    // style={{ background: "linear-gradient(90deg, #9333ea, #6366f1)" }}
    ,
    onClick: function onClick() {
      if (reviewRestrictedText) return;
      setLeaveTypeChange("Approve");
      handleReview(leaveId, "approved", attendanceType);
    },
    disabled: reviewRestrictedText || updateLeaveStatusLoading && leaveTypeChange == "Approve" || approvedStatusCheckForDisable ? true : false
  }, updateLeaveStatusLoading && leaveTypeChange == "Approve" ? "Loading..." : approvedStatusCheck ? "Approved" : "Approve"))), /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: reviewRestrictedText ? /*#__PURE__*/React.createElement(Tooltip, {
      id: "modal-reject-restricted-tooltip"
    }, reviewRestrictedText) : /*#__PURE__*/React.createElement("span", null)
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    className: "px-4 rounded-pill leave-details-modal-footer-button",
    onClick: function onClick() {
      if (reviewRestrictedText) return;
      setLeaveTypeChange("Reject");
      handleReview(leaveId, "rejected", attendanceType);
    },
    disabled: reviewRestrictedText || updateLeaveStatusLoading && leaveTypeChange == "Reject" || rejectedStatusCheckForDisable ? true : false
  }, updateLeaveStatusLoading && leaveTypeChange == "Reject" ? "Loading..." : rejectedStatusCheck ? "Rejected" : "Reject")))) : null);
};
var LeaveStatusChangeModal = function LeaveStatusChangeModal(props) {
  var changeLeaveStatusModal = props.changeLeaveStatusModal,
    handleChangeLeaveStatusClose = props.handleChangeLeaveStatusClose,
    organisationId = props.organisationId,
    reviewedLeaveList = props.reviewedLeaveList,
    setReviewedLeaveList = props.setReviewedLeaveList,
    organisationTimezone = props.organisationTimezone,
    planName = props.planName,
    setReasonText = props.setReasonText,
    reasonText = props.reasonText,
    errorText = props.errorText,
    setErrorText = props.setErrorText;
  if (changeLeaveStatusModal == null) {
    return false;
  }
  var leaveId = changeLeaveStatusModal.leaveId,
    leaveStatus = changeLeaveStatusModal.leaveStatus,
    userId = changeLeaveStatusModal.userId,
    attendanceType = changeLeaveStatusModal.attendanceType;
  var _useMutation3 = useMutation(UPDATE_LEAVE_STATUS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    updateLeaveStatus = _useMutation4[0],
    updateLeaveStatusLoading = _useMutation4[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(leaveId, leaveStatus, userId, attendanceType) {
      var leaveResponse;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!updateLeaveStatusLoading) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return updateLeaveStatus({
              variables: {
                organisationId: organisationId,
                leaveId: leaveId,
                leaveStatus: leaveStatus,
                timeZone: organisationTimezone,
                userId: userId,
                rejectedReasonText: leaveStatus !== "approved" && reasonText !== "" ? encodeHtmlEntities(reasonText) : null,
                freePlanStatus: planName,
                attendanceType: attendanceType
              }
            });
          case 5:
            leaveResponse = _context4.sent;
            if (!leaveResponse || !leaveResponse.data || leaveResponse.data.updateLeaveStatus == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              setReviewedLeaveList(function (oldLeave) {
                return [].concat(_toConsumableArray(oldLeave), [{
                  leaveId: leaveId,
                  leaveStatus: leaveStatus
                }]);
              });
              handleChangeLeaveStatusClose();
              toast.success("Leave ".concat(leaveStatus, " successfully!"));
              setReasonText("");
            }
            _context4.next = 13;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](2);
            if (_context4.t0.message == "Some of your employees are changed the status") {
              setErrorText("Something went wrong, Pls refresh the page");
            }
            console.log(_context4.t0);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 9]]);
    }));
    return function (_x4, _x5, _x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }(), [updateLeaveStatus, updateLeaveStatusLoading, reasonText, errorText, organisationId, organisationTimezone, planName, setReviewedLeaveList, handleChangeLeaveStatusClose, setReasonText, setErrorText]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: changeLeaveStatusModal,
    onHide: handleChangeLeaveStatusClose,
    animation: false,
    size: "md",
    className: "add-holiday-import-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "add-holiday-import-modal-header-title"
  }, leaveStatus == "approved" ? attendanceType !== "permission" ? "Approve Leave" : "Approve Short Leave" : attendanceType !== "permission" ? "Reject Leave" : "Reject Short Leave")), errorText !== "" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-leave-list-status-approved-modal-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, errorText))) : leaveStatus == "approved" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-leave-list-status-approved-modal-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to ".concat(leaveStatus == "approved" ? "approve" : "reject", " this ").concat(attendanceType !== "permission" ? "leave" : "short leave", "?")), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, leaveStatus == "approved" ? attendanceType !== "permission" ? "You can't undo this action once you've approved this leave." : "You can't undo this action once you've approved this short leave." : attendanceType !== "permission" ? "You can't undo this action once you've rejected this leave." : "You can't undo this action once you've rejected this short leave.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleChangeLeaveStatusClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: leaveStatus == "approved" ? "success" : "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleReview(leaveId, leaveStatus, userId, attendanceType);
    },
    disabled: updateLeaveStatusLoading ? true : false
  }, updateLeaveStatusLoading ? "Loading..." : leaveStatus == "approved" ? "Approve" : "Reject"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-leave-list-status-approved-modal-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to ".concat(leaveStatus == "approved" ? "approve" : "reject", " this ").concat(attendanceType !== "permission" ? "leave" : "short leave", "?")), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, leaveStatus == "approved" ? attendanceType !== "permission" ? "You can't undo this action once you've approved this leave." : "You can't undo this action once you've approved this short leave." : attendanceType !== "permission" ? "You can't undo this action once you've rejected this leave." : "You can't undo this action once you've rejected this short leave."), /*#__PURE__*/React.createElement(Form.Group, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "form-control-text-area-form-div-field-label-name "
  }, attendanceType !== "permission" ? "Leave" : "Short Leave", " Rejection Reason (optional)"), /*#__PURE__*/React.createElement(Form.Control, {
    className: "textFeedback",
    as: "textarea",
    rows: "3",
    placeholder: "",
    value: reasonText,
    onChange: function onChange(e) {
      return setReasonText(e.target.value);
    },
    type: "text"
  }))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleChangeLeaveStatusClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: leaveStatus == "approved" ? "success" : "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleReview(leaveId, leaveStatus, userId, attendanceType);
    }
    //type="submit"
    ,
    disabled: updateLeaveStatusLoading ? true : false
  }, updateLeaveStatusLoading ? "Loading..." : leaveStatus == "approved" ? "Approve" : "Reject"))));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    handleDeleteLeaveModalClose = props.handleDeleteLeaveModalClose,
    setDeleteLeaveData = props.setDeleteLeaveData,
    deleteLeaveData = props.deleteLeaveData,
    removeLeaveFromList = props.removeLeaveFromList,
    organisationTimezone = props.organisationTimezone,
    organisationId = props.organisationId,
    userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    last14Days = props.last14Days,
    organisationBilling = props.organisationBilling,
    leaveFilterCheck = props.leaveFilterCheck,
    setDeleteErrorText = props.setDeleteErrorText,
    deleteErrorText = props.deleteErrorText,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    startTime = props.startTime,
    leaveStartTime = props.leaveStartTime,
    endTime = props.endTime,
    leaveEndTime = props.leaveEndTime,
    role = props.role;
  if (show == null) {
    return null;
  }
  var currentYear = moment().format("YYYY");
  var userId = show.userId,
    dateDetails = show.dateDetails,
    leaveId = show.leaveId,
    attendanceType = show.attendanceType;
  var _useMutation5 = useMutation(DELETE_LEAVE_DETAILS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    deleteLeave = _useMutation6[0],
    deleting = _useMutation6[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _leaveSettingsApprove10, _leaveSettingsApprove11, tempDateDetails, variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!deleting) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.prev = 2;
            tempDateDetails = dateDetails.reduce(function (acc, curr) {
              acc.push({
                dayType: curr.dayType,
                date: curr.date,
                nonWorkingDayLeaveSession: curr.nonWorkingDayLeaveSession,
                dateFormatEmail: curr.dateFormatEmail
              });
              return acc;
            }, []);
            variables = {
              userId: userId,
              dateDetails: tempDateDetails,
              leaveId: leaveId,
              organisationId: organisationId,
              timeZone: organisationTimezone,
              deleteLeaveType: "manageLeave",
              freePlanStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
              attendanceType: attendanceType
            };
            _context5.next = 7;
            return deleteLeave({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_DETAILS_FOR_STATUS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                  leavePeriod: startDate ? moment(startDate).format("x") : null,
                  timeZone: organisationTimezone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null,
                  leaveFilterCheck: leaveFilterCheck && leaveFilterCheck.value ? leaveFilterCheck.value : null,
                  leaveYearStartTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove10 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove10 === void 0 ? void 0 : _leaveSettingsApprove10.leaveYearSettings) !== "financial-year" ? startTime : leaveStartTime,
                  leaveYearEndTime: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove11 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove11 === void 0 ? void 0 : _leaveSettingsApprove11.leaveYearSettings) !== "financial-year" ? endTime : leaveEndTime,
                  role: role
                }
              }]
            });
          case 7:
            response = _context5.sent;
            if (response && response.data && response.data.deleteLeave !== "") {
              deleteUser = _toConsumableArray(deleteLeaveData);
              deleteUser.push(response.data.deleteLeave);
              setDeleteLeaveData(_toConsumableArray(deleteUser));
              removeLeaveFromList(leaveId);
              handleDeleteLeaveModalClose();
              toast.success("Leave deleted successfully!");
            }
            _context5.next = 14;
            break;
          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](2);
            if (_context5.t0.message == "Some of your employees are changed the status") {
              setDeleteErrorText("Something went wrong, Pls refresh the page");
            }
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 11]]);
    }));
    return function onDeleteSubmit() {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleDeleteLeaveModalClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, attendanceType == "permission" ? "Delete Short Leave" : "Delete Leave")), deleteErrorText !== "" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, deleteErrorText, " "))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", attendanceType == "permission" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this Short leave?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this short leave.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this leave?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this leave."))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleDeleteLeaveModalClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Delete"))));
};
export var LeaveManagementEnableFeature = function LeaveManagementEnableFeature(props) {
  var displayName = props.displayName,
    history = props.history,
    role = props.role;
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text"
  }, role == "Admin" ? /*#__PURE__*/React.createElement("p", {
    className: "timelapse-warning-text-p"
  }, "Dear ", displayName, ", The Leave Management feature is currently disabled. Please navigate to", " ", /*#__PURE__*/React.createElement("div", {
    className: "timelapse-warning-text-p-a",
    onClick: function onClick() {
      return history.push("/settings/track-settings");
    }
  }, "Settings - Track Settings"), " ", "to enable it.", " ") : /*#__PURE__*/React.createElement("p", {
    className: "timelapse-warning-text-p"
  }, "Dear ", displayName, ", The Leave Management feature has been disabled by your Workfolio admin; please contact them for assistance.", " ")));
};
export default AdminViewLeave;